// Lightweight global toast helper.
//
// Fires a custom event the <ToastHost /> in App.js listens for. Anywhere
// in the app:
//
//   import { showToast } from '../utils/toast';
//   showToast('הפרופיל עודכן — התכנית תתעדכן בהתאם');
//   showToast('משהו השתבש', 'error');
//
// type: 'success' (default) | 'error' | 'info'.
// duration: ms before auto-dismiss (default 3500).
//
// Why a custom event instead of a context/store: same pattern we
// already use for plan-regen-start/done banners. Any module — even
// outside React, e.g. authFetch.js helpers — can call it without
// pulling in a hook chain.
export function showToast(message, type = 'success', duration = 3500) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('app-toast', {
    detail: { message, type, duration },
  }));
}
